var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('top-navigation',{ref:"nav",on:{"select":_vm._menuLeafSelHandler,"default":_vm._setDefaultTag}}),_c('tag-frame',{ref:"tag",staticStyle:{"top":"56px"},on:{"shift":_vm.tagShiftHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }